import { combineReducers } from '@reduxjs/toolkit'

import { reducer as paramUrl } from './paramUrl'

export default combineReducers({ paramUrl })
